import React from "react";
import { Phone, Mail, MapPin } from "lucide-react";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="relative bg-slate-950 text-white pt-20 pb-10 overflow-hidden" data-testid="site-footer">
      <div className="absolute inset-0 bg-grain opacity-30" />
      <div className="relative mx-auto max-w-7xl px-5 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-6">
            <h3 className="font-display text-4xl md:text-6xl leading-[0.95] tracking-tight">
              SHRI GURUNATH<br />
              <span className="italic text-amber-500">ENTERPRISES</span>
            </h3>
            <p className="mt-5 max-w-md text-white/60 leading-relaxed">
              Importers & distributors of premium carpets, wallpapers and wooden flooring. Direct from container to your project — across Karnataka & South India.
            </p>
            <p className="mt-6 italic font-display text-amber-400/90 text-xl">&ldquo;We floor you with style.&rdquo;</p>
          </div>
          <div className="lg:col-span-3">
            <p className="eyebrow !text-amber-500 mb-4">Navigate</p>
            <ul className="space-y-2 text-white/70 text-sm">
              {[
                ["Home", "#home"],
                ["Collection", "#collection"],
                ["Wholesale Benefits", "#advantages"],
                ["Testimonials", "#testimonials"],
                ["Contact Us", "#contact"],
              ].map(([l, h]) => (
                <li key={h}>
                  <a href={h} className="hover:text-amber-400 transition-colors" data-testid={`footer-link-${l.toLowerCase().replace(/\s+/g, "-")}`}>{l}</a>
                </li>
              ))}
            </ul>
          </div>
          <div className="lg:col-span-3">
            <p className="eyebrow !text-amber-500 mb-4">Reach Us</p>
            <ul className="space-y-3 text-white/70 text-sm">
              <li className="flex items-start gap-2"><MapPin className="h-4 w-4 text-amber-500 mt-[3px]" /> 2/1, 3rd Cross, Lal Bagh Main Rd, Bengaluru 560027</li>
              <li className="flex items-center gap-2"><Phone className="h-4 w-4 text-amber-500" /> <a href="tel:09845048406" className="hover:text-amber-400">098450 48406</a></li>
              <li className="flex items-center gap-2"><Mail className="h-4 w-4 text-amber-500" /> <a href="mailto:gurunathenterprises@gmail.com" className="hover:text-amber-400">gurunathenterprises@gmail.com</a></li>
            </ul>
          </div>
        </div>
        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <p className="text-xs text-white/50 tracking-wide">© {year} Shri Gurunath Enterprises. All rights reserved.</p>
          <p className="text-xs text-white/40 tracking-[0.2em] uppercase">Bengaluru · Karnataka · India</p>
        </div>
      </div>
    </footer>
  );
}
